// extracted by mini-css-extract-plugin
module.exports = {"logo__div":"logo_logo__div__3mANa","logo__link":"logo_logo__link__1LbKV"};